import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { noop } from 'lodash/fp';
import { DialogType, StatusDialog } from 'app/components/composite/StatusDialog';
import { navigateToGoogleIntegration } from 'app/routes';

export const IntegrationUnconfiguredDialog = ({
    isOpen = false,
    canUserManageIntegrations = false,
    onToggleDialog = noop
}) => {
    const { t } = useTranslation();
    const getMessage = (key) => t(`components:IntegrationUnconfiguredDialog.${key}`);

    if (!isOpen) {
        return null;
    }

    const submitButtonLabel = canUserManageIntegrations
        ? getMessage('goToSettings')
        : t('common:close');
    const dialogMessage = canUserManageIntegrations
        ? getMessage('configureGoogleIntegration')
        : getMessage('contactAdministrator');
    const handleSubmit = () =>
        canUserManageIntegrations ? navigateToGoogleIntegration() : onToggleDialog(false);

    return (
        <StatusDialog
            title={getMessage('title')}
            submitButtonLabel={submitButtonLabel}
            type={canUserManageIntegrations ? DialogType.WARNING : DialogType.INFO}
            onSubmit={handleSubmit}
            onClose={() => onToggleDialog(false)}>
            {dialogMessage}
        </StatusDialog>
    );
};

IntegrationUnconfiguredDialog.propTypes = {
    isOpen: PropTypes.bool,
    canUserManageIntegrations: PropTypes.bool,
    onToggleDialog: PropTypes.func
};
